import axios from "axios";

export async function transcribeDictation(audioBlob: Blob): Promise<string> {
  const formData = new FormData();
  formData.append("audio", audioBlob, "dictation.webm");
  const response = await axios.post("/api/services/transcribe-dictation/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data?.transcription?.trim?.() || "";
}
